import { List, ListItem, ListItemIcon, Switch, Typography } from '@material-ui/core';
import React from 'react'
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom';
import HomeRoundedIcon from "@material-ui/icons/HomeRounded";
import StoreRoundedIcon from "@material-ui/icons/StoreRounded";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import StarsIcon from "@material-ui/icons/Stars";
import ContactsRoundedIcon from "@material-ui/icons/ContactsRounded";
import InfoRoundedIcon from "@material-ui/icons/InfoRounded";
import { withStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";

import {
    toggletheme,
} from "../actions/mainAction";
import { toogleDrawer } from "../actions/authActions";


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    nav: {
        textDecoration: "none",
        color: "inherit",
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up("sm")]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 160,
    },

    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up("sm")]: {
            display: "none",
        },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginLeft: window.innerWidth > 700 ? "15rem" : "0",
    },
    root: {
        marginBottom: "3rem",
        padding: "1px",
        borderRadius: "0.5rem",
        maxWidth: 345,
        margin: "auto",
        transition: "0.3s",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        "&:hover": {
            boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)",
        },
    },
    media: {
        height: "250px",
        width: "94%",
        maxWidth: "400px",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        margin: "9px",
    },
    boxheader: {
        height: "2.5rem"
    }

}));


const IOSSwitch = withStyles((theme) => ({
    root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
    },
    switchBase: {
        padding: 1,
        "&$checked": {
            transform: "translateX(16px)",
            color: theme.palette.common.white,
            "& + $track": {
                backgroundColor: "#52d869",
                opacity: 1,
                border: "none",
            },
        },
        "&$focusVisible $thumb": {
            color: "#52d869",
            border: "6px solid #fff",
        },
    },
    thumb: {
        width: 24,
        height: 24,
    },
    track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(["background-color", "border"]),
    },
    checked: {},
    focusVisible: {},
}))(({ classes, ...props }) => {
    return (
        <Switch
            focusVisibleClassName={classes.focusVisible}
            disableRipple
            classes={{
                root: classes.root,
                switchBase: classes.switchBase,
                thumb: classes.thumb,
                track: classes.track,
                checked: classes.checked,
            }}
            {...props}
        />
    );
});
function Menu(props) {
    const classes = useStyles();
    const theme = useTheme();

    const drawer = (
        <div>
            <div
            // className={classes.toolbar}

            />
            <Box className={classes.boxheader}>
                <Typography variant="h6" style={{ marginTop: "1rem" }} align="center">{props.website.website.header}</Typography>
            </Box>
            <Divider />
            <List>
                <NavLink to="/" className={classes.nav}>
                    <ListItem button selected={window.location.pathname == "/" ? true : false}>
                        <ListItemIcon>
                            <HomeRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Home"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/shop" className={classes.nav}>
                    <ListItem button selected={window.location.pathname == "/shop" ? true : false}>
                        <ListItemIcon>
                            <StoreRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Shop"} />
                    </ListItem>
                </NavLink>
                {props.auth.isAuthenticated ? (
                    <NavLink to="/cart" className={classes.nav}>
                        <ListItem button selected={window.location.pathname == "/cart" ? true : false}>
                            <ListItemIcon>
                                <ShoppingCartRoundedIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Cart"} />
                        </ListItem>
                    </NavLink>
                ) : null}
                {props.auth.isAuthenticated ? (
                    <NavLink to="/wishlist" className={classes.nav}>
                        <ListItem button selected={window.location.pathname == "/wishlist" ? true : false}>
                            <ListItemIcon>
                                <StarsIcon color="primary" />
                            </ListItemIcon>
                            <ListItemText primary={"Wishlist"} />
                        </ListItem>
                    </NavLink>
                ) : null}

                <NavLink to="/contact" className={classes.nav}>
                    <ListItem button selected={window.location.pathname == "/contact" ? true : false}>
                        <ListItemIcon>
                            <ContactsRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"Contact Us"} />
                    </ListItem>
                </NavLink>
                <NavLink to="/about" className={classes.nav}>
                    <ListItem button selected={window.location.pathname == "/about" ? true : false}>
                        <ListItemIcon>
                            <InfoRoundedIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={"About Us"} />
                    </ListItem>
                </NavLink>

                <ListItem button>
                    <ListItemIcon>
                        <IOSSwitch
                            checked={props.main.theme == "dark"}
                            onChange={() => {
                                props.toggletheme();
                            }}
                            name="checkedB"
                        />
                    </ListItemIcon>
                    <ListItemText primary={"Dark Mode"} />
                </ListItem>
            </List>
        </div>
    );
    const container =
        window !== undefined ? () => window.document.body : undefined;

    return (
        <div>
            <nav className={classes.drawer} aria-label="mailbox folders">
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}

                <Drawer
                    container={container}
                    variant="temporary"
                    anchor={theme.direction === "rtl" ? "right" : "left"}
                    open={props.auth.drawer}
                    onClose={() => { props.toogleDrawer() }}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    {drawer}
                </Drawer>


            </nav>

        </div>
    )
}
const mapStateToProps = (state) => ({
    main: state.main,
    auth: state.auth,
    website: state.website,
});

export default connect(mapStateToProps, {
    toggletheme,
    toogleDrawer
})(Menu);